import { useEffect, useState } from "react";
import { SpeakerModal } from '../SpeakerModal';
import { CarouselSlider } from '../CarouselSlider';

export const ImgSlider = ({ speakers }) => {
   const [speakerIdx, setSpeakerIdx] = useState(null);
   const [imageCount, setImageCount] = useState(2);

   const handleClose = () => setSpeakerIdx(null);

   useEffect(() => {
      function updateImageCount() {
         if (window.matchMedia('(min-width: 1575px)').matches) {
            setImageCount(4);
         } else if (window.matchMedia('(min-width: 1275px)').matches) {
            setImageCount(3);
         } else if (window.matchMedia('(min-width: 925px)').matches) {
            setImageCount(2);
         } else {
            setImageCount(1)
         };
      }
      window.addEventListener('resize', updateImageCount);
      updateImageCount();
      return () => window.removeEventListener('resize', updateImageCount);
   }, []) // eslint-disable-line 

   if (!speakers) return <></>
   const slides = [];

   for (let i = 0; i < speakers.length; i += imageCount) {
      slides.push(speakers.slice(i, i + imageCount));
   }

   return (
      <div className='img-slider'>
       <CarouselSlider data={slides}>
               {slides.map((slide, slideIdx) => (
                  <div key={slideIdx} className='speakers'>
                     {slide.map((card, cardIdx) => (
                        <div
                           key={cardIdx}
                           className='speaker'
                           onClick={() => {
                              setSpeakerIdx(slideIdx * imageCount + cardIdx);
                           }}
                        >
                           <img
                              key={card?.headshot_url}
                              src={require(`../../assets/imgs/speaker-headshots/${card?.headshot_url}`)}
                              alt={card?.headshot_url}
                           />
                           <ul>
                              <li>{card?.is_moderator ? 'Moderator' : 'Speaker'}</li>
                              <li>{card?.firstname} {card?.lastname}</li>
                              <li>{card?.jobtitle?.slice(0, 20) + (card?.jobtitle?.length > 20 ? "..." : "")}</li>
                              <li>{card?.company?.slice(0, 20) + (card?.company?.length > 20 ? "..." : "")}</li>
                           </ul>
                        </div>
                     ))}
                  </div>
               ))}
            </CarouselSlider>
         {
            speakerIdx !== null &&
            <div className="modal-container" >
               <div className="speakere-modal" onBlur={() => setSpeakerIdx(null)}>
                  <SpeakerModal speakers={speakers} speakerIdx={speakerIdx} handleClose={handleClose} />
               </div>
            </div>
         }
      </div >
   );
};
